import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { ChangeLog, ChangeLogItem } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export type ChangeLogItemModel = Omit<
  RequireSome<Partial<ChangeLogItem>, 'id'>,
  'expense_amounts' | 'organization'
> & {
  expense_amounts: { amount?: null | number | undefined; amount_type: string }[];
  file_link?: string;
  investigator_amount: number;
  organization: {
    id: string;
    name: string;
  };
  passthrough_amount: number;
  service_amount: number;
  total_amount: number;
};

export type ChangeLogModel = getEntityType<ChangeLogState>;

export interface ChangeLogState
  extends ActiveState,
    EntityState<
      Omit<RequireSome<Partial<ChangeLog>, 'id'>, 'trial_id'> & {
        change_log_items: ChangeLogItemModel[];
        clis_total: string;
        investigator_fee_percent: number;
        investigator_fees_total: string;
        pass_thru_percent: number;
        pass_thru_total: string;
        services_percent: number;
        services_total: string;
      },
      string
    > {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'change-log' })
export class ChangeLogStore extends EntityStore<ChangeLogState> {
  constructor() {
    super({});
  }
}
